import * as React from 'react';

import * as styles from './styles.css';
import { ICommonNewbuilding } from '../../types/newbuilding/newbuildings';
import { LayoutWithHeader } from '../LayoutWithHeader';
import { NewbuildingCard } from '../NewbuildingCard';

interface INewbuildingsProps {
  title: string;
  regionId: number | null;
  newbuildings: ICommonNewbuilding[];
  link?: React.ReactNode;
  onNewbuildingClick(index: number): void;
}

export function Newbuildings({ title, regionId, newbuildings, link, onNewbuildingClick }: INewbuildingsProps) {
  return (
    <LayoutWithHeader title={title}>
      <div className={styles['content']}>
        {newbuildings.map((newbuilding, index) => (
          <NewbuildingCard
            key={newbuilding.name}
            imageUrl={newbuilding.imageUrl}
            builder={newbuilding.builderNames[0]}
            name={newbuilding.name}
            fullUrl={newbuilding.fullUrl}
            price={newbuilding.priceFromDisplay}
            status={newbuilding.buildingStatusInfo}
            regionId={regionId}
            undergroundColor={newbuilding.undergroundColor}
            undergroundName={newbuilding.undergroundName}
            transportType={newbuilding.transportType}
            undergroundTimeTo={newbuilding.undergroundTimeTo}
            onClick={() => onNewbuildingClick(index)}
          />
        ))}
      </div>
      {link}
    </LayoutWithHeader>
  );
}
